import { render, staticRenderFns } from "./USMarket.vue?vue&type=template&id=2ea8d2fb&scoped=true"
import script from "./USMarket.vue?vue&type=script&lang=js"
export * from "./USMarket.vue?vue&type=script&lang=js"
import style0 from "./USMarket.vue?vue&type=style&index=0&id=2ea8d2fb&prod&scoped=true&lang=css"
import style1 from "./USMarket.vue?vue&type=style&index=1&id=2ea8d2fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea8d2fb",
  null
  
)

export default component.exports